import React, { useState, useEffect, useCallback } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useHttp } from '../../../hooks/http.hook';

const PostbackUrl = () => {
    const { request } = useHttp();
    const [record, setRecord] = useState(null); // { id, url, is_active }
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");

    const fetchPostbackUrl = useCallback(async () => {
        try {
            const data = await request('/api/utils/postback-urls', 'GET');
            const active = Array.isArray(data) && data.find(r => r.is_active);
            setRecord(active || null);
        } catch (e) {
            console.error(e);
        }
    }, []);

    useEffect(() => {
        fetchPostbackUrl();
    }, []);

    const handleDoubleClick = () => {
        setDraft(record ? record.url : "");
        setEditing(true);
    };

    const handleCancel = () => {
        setEditing(false);
    };

    const handleSave = async () => {
        try {
            if (record) {
                await request(`/api/utils/postback-urls/${record.id}`, 'PUT', { url: draft });
            } else {
                await request('/api/utils/postback-urls', 'POST', { url: draft, is_active: true });
            }
            await fetchPostbackUrl();
            setEditing(false);
        } catch (e) {
            console.error(e);
        }
    };

    if (editing) {
        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '20px', gap: '8px' }}>
                <TextField
                    size="small"
                    variant="standard"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    label="Postback URL"
                    style={{ minWidth: 300 }}
                    autoFocus
                />
                <Button size="small" onClick={handleCancel}>Отмена</Button>
                <Button size="small" variant="contained" onClick={handleSave}>Сохранить</Button>
            </span>
        );
    }

    return (
        <span
            style={{ marginLeft: '20px', cursor: 'pointer', fontSize: '14px' }}
            onDoubleClick={handleDoubleClick}
            title="Двойной клик для редактирования"
        >
            Postback URL: <strong>{record ? record.url : "не задан"}</strong>
        </span>
    );
};

export default PostbackUrl;
